<template>
   <div class="emb-termCondition-wrap">
		<emb-page-title
			:heading="TopSection.Heading"
			:subHeading="TopSection.Sub_Heading"
      :image="TopSection.Image_1366_x_552px"
		>
		</emb-page-title>
		<div class="emb-tnc section-gap">
         <div class="container">
            <div class="tnc-content">
                <div class="emb-card mb-12 pa-6" v-for="(data,i) in MainContent.Terms_and_Conditions_List" :key="i">
                    <h4 class="mb-4">{{data.Title}}</h4>
                    <div v-html="data.Terms_And_Conditions_Content">
                    </div>
                </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
// import api from "Api";
import { mapGetters } from "vuex";
import gettingRestClientObject from "../../services/utils/cms-helper";
export default {
  computed: {
    ...mapGetters(["rtlLayout","selectedLocale"])
  },
  data() {
    return {
      TopSection:{},
      MainContent:{}
    };
  },
   watch: {
    selectedLocale: function () {
     
    this.getFaq();
    },
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getFaq();
  },
  methods: {
     	getFaq: function() {
			var self = this;

			var language = localStorage.Language? localStorage.Language : "en";

			var config = {
			pageType: "Template/",
			pageUrl : "22 Terms and Conditions/22 Terms and Conditions/22 Terms and Conditions.ftl",
			lang :language,

			successCallback: function(response) {
			var res = response.data;

			if (res.area_List) {
			var bannerArea = self.cmsRequestFunctions.pluck("Top_Section",res.area_List);
      self.TopSection = self.cmsRequestFunctions.getAllMapData(bannerArea[0].component);
      
			var Main= self.cmsRequestFunctions.pluck("Main_Content",res.area_List);
			self.MainContent = self.cmsRequestFunctions.getAllMapData(Main[0].component);
			
			}
			},
			errorCallback: function(error) {
			console.log(error);
			}
			};
			this.cmsRequestFunctions.cmsRequest(config,language);
},
    // getFaq() {
    //   api
    //     .get("term_condition.json")
    //     .then(response => {
    //       this.tnc = response.data;
    //       // console.log(this.tnc);
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // }
  }
};
</script>

